import axios from 'axios';






import { ActivityInfo, CollectionInfo, HomeInfo, pageInfo, ProductInfo, ShowInfo, TitleInfo } from '../models/system';
import { baseUrl } from '../config';
import { PageInfo } from '../views/components/Pager';





export const getHomeInfo = async (isopen: boolean): Promise<HomeInfo> => {

    let c = await axios.get(baseUrl + '/museum?isopen=' + isopen);

    return c.data as HomeInfo;
}

export interface searchResult { title: string, type: number, description: string };

export interface showingResult extends searchResult {
    address: string;
    time: string;
}

export interface savingResult extends searchResult {
    kind: string;
    time: string;
}
export interface ActivityResult extends searchResult {
    address: string;
    host: string;
    time: string;
}
export const search = async (key: string | null, page: number) => {
    key = key == null || key == undefined ? sessionStorage.getItem("search_key") : key;
    let c = await axios.get(baseUrl + '/search', { params: { key: key, page: page } });

    return c.data as pageInfo<searchResult>;
}

export const getArticles = async (page: number, size: number, catid: number): Promise<pageInfo<TitleInfo>> => {
    let key = sessionStorage.getItem("search_key");
    key = null;
    let c = await axios.get(baseUrl + '/articleList', { params: { page, size, catid, key } });

    return c.data as pageInfo<TitleInfo>;
}

export interface VideoInfo { url: string, title: string, id: number, pic: string, address: string, date: string };

export const getVideos = async (page: number, size: number, catid: number): Promise<pageInfo<VideoInfo>> => {
    let c = await axios.get(baseUrl + '/Videos', { params: { page, size } });

    return c.data as pageInfo<VideoInfo>;
}

export const updateVisitLeader = async () => {
    let c = await axios.get(baseUrl + '/updateVisitLeader');
    return null;
}

export const getNews = async (page: number, size: number): Promise<TitleInfo[]> => {
    let c = await axios.get(baseUrl + '/news', { params: { page, size } });

    return c.data as TitleInfo[];
}
export const getProducts = async (page: number, size: number): Promise<pageInfo<ProductInfo>> => {
    let c = await axios.get(baseUrl + '/products', { params: { page, size } });
    return c.data as pageInfo<ProductInfo>;
}

export const getProduct = async (id: string): Promise<ProductInfo> => {

    let c = await axios.get(baseUrl + '/product', { params: { id: parseInt(id) } });

    return c.data as ProductInfo;
}


export const getCollection = async (id: string): Promise<CollectionInfo> => {

    let c = await axios.get(baseUrl + '/collection', { params: { id: parseInt(id) } });

    return c.data as CollectionInfo;
}
export const getArticle = async (id: string): Promise<TitleInfo> => {

    let c = await axios.get(baseUrl + '/article', { params: { id: parseInt(id) } });

    return c.data as TitleInfo;
}
export const getEduAcvities = async (page: number, size: number, type: number = 1): Promise<pageInfo<ActivityInfo>> => {
    let key = sessionStorage.getItem("search_key");
    let c = await axios.get(baseUrl + '/activities', { params: { page, size, type, key } });

    return c.data as pageInfo<ActivityInfo>;
}

export const getCollections = async (type: number, page: number, size: number): Promise<pageInfo<CollectionInfo>> => {
    let key = sessionStorage.getItem("search_key");
    let c = await axios.get(baseUrl + '/collections', { params: { type, page, size, key } });
    return c.data as pageInfo<CollectionInfo>;
}


export const getShowings = async (type: number, page: number, size: number, year?: number) => {

    let c = await axios.get(baseUrl + '/showings', { params: { type: type, page: page, size: size, year: year } });

    return c.data as pageInfo<ShowInfo>;
}

export const getShowingYears = async (type: number, take: number) => {
    let c = await axios.get(baseUrl + '/showingYears', { params: { type: type, take: take } });
    return c.data as number[];
}